const stripeVerificationStatus = {
    UNVERIFIED: 'unverified',
    VERIFIED: 'verified',
    PENDING: 'pending',
};
export default stripeVerificationStatus;
